import Vue from 'vue';
export default Vue.extend({
    data: function () {
        return {
            sendForm: {
                yzm: '',
            },
            captcha_url: '',
            sendFormRules: {
                yzm: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                    { min: 4, max: 4, message: '请输入4位验证码', trigger: 'blur' },
                ],
            },
            count: this.$store.state.info.sendCount,
        };
    },
    props: {
        templateCode: {
            type: Number,
            required: true,
        },
        uploadKey: {
            type: String,
            default: function () {
                return '';
            },
        },
    },
    created: function () {
        this.getYzm();
    },
    methods: {
        getYzm: function () {
            var _this = this;
            this.$request({
                method: 'post',
                url: '/proxy/api/captcha/get',
                data: {
                    targetModule: 'send-message',
                },
            }).then(function (res) {
                if (!res)
                    return;
                if (res && !res.errorCode) {
                    _this.captcha_url = res.data;
                }
            });
        },
        sendMain: function () {
            var _this = this;
            this.$refs['sendForm'].validate(function (valid) {
                if (!valid) {
                    return;
                }
                var params = {
                    templateCode: _this.templateCode,
                    uploadKey: _this.uploadKey,
                    captcha: _this.sendForm.yzm,
                };
                _this.$request({
                    method: 'post',
                    url: '/proxy/api/msg/send/do',
                    data: params,
                }).then(function (res) {
                    if (!res)
                        return;
                    if (res && !res.errorCode) {
                        var data = res.data;
                        if (!data.result) {
                            if (data.desc === 'CAPTCHAERROR') {
                                _this.sendForm.yzm = '';
                                _this.getYzm();
                                _this.$message.error('验证码错误');
                                return;
                            }
                            _this.$message.error('系统错误');
                            return;
                        }
                        _this.$emit('to-success', data);
                    }
                });
            });
        },
    },
});
